export const resetTimeForDate = (date: Date) => {
  const result = new Date(date);
  result.setHours(0);
  result.setMinutes(0);
  result.setSeconds(0);
  result.setMilliseconds(0);
  return result;
};

export const addDay = (date: Date, daysToAdd: number) => {
  const result = new Date(date);
  result.setDate(result.getDate() + daysToAdd);
  return result;
};

export const isSameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();
